import { NgModule } from '@angular/core';
import { TranslationPipe } from '../../services';
import { EtherDecimalFixedPipe } from '../pipes';

@NgModule({
  imports: [],
  providers: [],
  declarations: [EtherDecimalFixedPipe],
  exports: [EtherDecimalFixedPipe],
  bootstrap: [],
  entryComponents: [],
  schemas: [],
})
export class EtherDecimalFixedModule {}
